import React, { Component } from "react";
import { FormControl, MenuItem } from '@mui/material';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import Typography from '@mui/material/Typography';
import settings from "../../helpers/Settings";
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from "@iconify/react";
import { IconButton } from '@mui/material';
import Cookies from "js-cookie";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

let { KayanURL } = settings;
class AddCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      items: [],
      activebtn: false,
      addLicensetotable: false,
      licenseDuplicate: false,
      licenseValue: false,
      removeLicenseInputValue: false,
    };
  }
  componentDidMount = async () => {
  };
  addCompany = async (event) => {
    event.preventDefault();
    this.setState({
      responseReady: false,
      addCompanyRequestSent: true,
    });
    const result = await axios.put(KayanURL + "api/KSA/RCM/admin/addCompany", {
      data: this.state.data,
      apiToken: Cookies.get("RCM_KSA_Admin_Token"),
    });

    if (result) {
      let { data } = result;
      this.setState({ addCompanyRequestSent: false, responseReady: true });
      if (data.success) {
        this.setState({
          AddCompanySuccess: true,
          items: [],
          messageflag: true,
          message: "Company Added successfully ",
        });
        this.props.closeAddNewCompanyModal();
      } else {
        this.setState({
          AddCompanySuccess: false,
          flag: true,
          message: data.error,
        });
      }
    }
  };
  addCompanyHandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      data: { ...this.state.data, [name]: value },
    });
  };
  render() {
    return (
      <>
        <div >
          <Container>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: "center", marginBottom: "20px" }}>
              Company Information
            </Typography>
            <div style={{ width: "50%",margin:"auto" }}>
            <Row>
                <div style={{ width: "252px",margin:"auto" }}>
                  <FormControl fullWidth sx={{ mb: 3 }} >
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }} required
                      label="Company Name" variant="outlined"
                      name="name"
                      onChange={this.addCompanyHandleInputTextChange}
                    />
                  </FormControl>

                   
                     <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="nphiesProvider"
                      type="text" label="Naphies Provider ID"
                      variant="outlined" onChange={this.addCompanyHandleInputTextChange}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="nphiesProviderName"
                      type="text" label="Naphies Provider Name"
                      variant="outlined" onChange={this.addCompanyHandleInputTextChange}
                    />
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="username" label="User Name"
                      variant="outlined" onChange={this.addCompanyHandleInputTextChange}
                    />
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                      inputProps={{ sx: { padding: "11px" } }}
                      required name="password"
                      type="password" label="Password"
                      variant="outlined" onChange={this.addCompanyHandleInputTextChange}
                    />
                  </FormControl>


                  <Button variant="primary" type="submit"
                    onClick={(e) => this.addCompany(e)}
                    style={{
                      width: "100%"
                      , marginTop: "32px"
                      , backgroundColor: "rgb(97 110 120"
                      , border: "1px solid rgb(97 110 120"
                    }}>
                    Add
                  </Button>
                </div>
              
              {this.state.addCompanyRequestSent && !this.state.responseReady ? (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Spinner animation="border" variant="success" />
                </div>
              ) : null}

              {this.state.responseReady && this.state.AddCompanySuccess ? (
                <div style={{ textAlign: "center" }}>
                  <h5 style={{
                    color: "green",
                    textAlign: "center",
                    color: "blue",
                    marginTop: "20px"
                  }}>{this.state.message}</h5>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <h5 style={{ color: "red" }}>{this.state.message}</h5>
                </div>
              )}
            </Row>
            </div>
            
          </Container>
        </div>
      </>
    );
  }
}

export default AddCompany;
